import { useAuth0 } from '@auth0/auth0-react'
import { useState } from 'react'
import { AI_SERVICE_BASE_URL } from '../env'

export const useAITagGeneration = () => {
  const [loading, setLoading] = useState(false)
  const { getAccessTokenSilently } = useAuth0()

  const generateTagsWithAI = async ({
    seedWords,
    existingTags
  }: {
    seedWords: string[]
    existingTags: string[]
  }): Promise<{ suggestedTags: string[] } | undefined> => {
    try {
      setLoading(true)
      const res = await fetch(`${AI_SERVICE_BASE_URL}/admin/tags/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Vestaboard-Token': await getAccessTokenSilently()
        },
        body: JSON.stringify({
          seedWords,
          existingTags
        })
      })

      return await res.json()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    generateTagsWithAI,
    loading
  }
}
